<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form>
				<div class="formgroup">
					<div class="flex justify-content-center mt-3" *ngIf="loadingContrato">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-auto mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid" *ngIf="contrato && !loadingContrato">
						<div class="col-12 px-5 pt-5">
							<div class="grid card-simple">
								<div class="col-12 md:col-3">
									<label class="label-superior">Razão Social</label>
									<label class="label-inferior" id="razaoSocial">{{ contrato.razaoSocial }}</label>
								</div>
								<div class="col-12 md:col-3">
									<label class="label-superior">CNPJ</label>
									<label class="label-inferior" id="cnpj">{{ contrato.cnpj | cnpjFormat }}</label>
								</div>
								<div class="col-12 md:col-3">
									<label class="label-superior">CPF do Titular</label>
									<label class="label-inferior" id="cpf">{{ contrato.cpfTitular | cpfFormat }}</label>
								</div>
								<div class="col-12 md:col-3">
									<label class="label-superior">Empresa</label>
									<label class="label-inferior" id="empresa">{{ contrato.empresa?.nomeFantasia}}</label>
								</div>
		
								<div class="col-12 md:col-2">
									<label class="label-superior">Status</label>
									<div class="label-inferior">
										<label class="product-badge status-instock" id="status"
											*ngIf="contrato.ativoContratante">ATIVO CONTRATANTE</label>
										<label class="product-badge status-outofstock" id="status"
											*ngIf="!contrato.ativoContratante">INATIVO CONTRATANTE</label>
									</div>
								</div>
							</div>

						</div>

						<div class="col-12 md:col-12">
							<h5>Rateio</h5>
						</div>
						<div class="w-full px-3 mb-5">
							<p-table #dt1 [value]="listaRateios" dataKey="id" [rows]="10" [rowHover]="true"
								styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
								styleClass=" p-datatable-sm">
								<ng-template pTemplate="header">
									<tr>
										<th>
											<div>
												Subgrupo
											</div>
										</th>
										<th>
											<div>
												Percentual <i  class="pi pi-question-circle"
												pTooltip="Este percentual será utilizado na dedução tributária da NFS-e."></i>
											</div>
										</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td>
											<label>{{ item.subgrupo.descricao }}</label>
										</td>
										<td>
											<label>{{ (item.percentualRateio / 100) | percent:'1.2-2' }}</label>
										</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum registro cadastrado.</td>
									</tr>
								</ng-template>
							</p-table>
						</div>
					</div>
					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loadingContrato">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/contrato"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>